"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Levels = exports.createLogger = exports.getLogger = void 0;
var logger_types_1 = require("./logger.types");
var getLogger = function (category) {
    var log = {};
    logger_types_1.levels.forEach(function (level) {
        log[level] = function (msg, metadata) {
            if (level === 'error') {
                console.error(level, msg, Object.assign({ category: category }, metadata));
            }
            else {
                console.log(level, msg, Object.assign({ category: category }, metadata));
            }
        };
    });
    return log;
};
exports.getLogger = getLogger;
exports.createLogger = exports.getLogger;
exports.Levels = {
    info: 'info',
    debug: 'debug',
    warn: 'warn',
    error: 'error',
    trace: 'trace',
};
